import { useMapEvents } from "react-leaflet";

export const LocationPicker = ({ setPosition}) => {
  useMapEvents({
    click(e) {
      setPosition(e.latlng);
      console.log(e)
    }
  });

  return null;
}